module.exports = __webpack_public_path__ + "img/img.43a33de2.png";